<template>
  <div>
    <section>
      <div class="container text-center">
        <!-- <img src="@/assets/img/404.gif" class="img-fluid" alt="Error-404"> -->
        <h4 class="font-weight-bold" style="padding-top: 100px;">Coming Soon</h4>
        <p class="font-weight-bold">We are still working on this, come back soon.</p>
        <router-link class="btn-gogo mx-auto" to="/">Go to Home</router-link>
        <img src="@/assets/img/svg/SeparatorOR.svg" class="img-fluid my-4" />
        <h6>Browse through our film library</h6>
      </div>
    </section>

    <!-- NOW SHOWING MOVIES SLIDER -->
    <section>
      <div class="container-fluid my-5">
        <NowShowing />
      </div>
    </section>
  </div>
</template>

<script>
import Slick from "vue-slick";
import NowShowing from "@/components/partials/nowShowingSlider.vue";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";

export default {
  name: "homepage",
  components: {
    Slick,
    NowShowing
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/comingSoon.vue